import { useState, createContext } from 'react';

const FarmContext = createContext({
  farmID: null,
  setFarmID: () => {},
  clearFarmID: () => {},
});

export const FarmContextProvider = (props) => {
  const getStoredFarmID = () => {
    const tokenItem = parseInt(localStorage.getItem('farmID'));
    return tokenItem;
  };

  const [selectedFarmID, setSelectedFarmID] = useState(
    !isNaN(getStoredFarmID()) ? getStoredFarmID() : null
  );

  const setStoredFarmID = (id) => {
    localStorage.setItem('farmID', id);
  };

  const clearStoredFarmID = () => {
    localStorage.removeItem('farmID');
    setSelectedFarmID(null);
  };

  const setFarmID = (id) => {
    setSelectedFarmID(id);
    setStoredFarmID(id);
  };

  return (
    <FarmContext.Provider
      value={{
        farmID: selectedFarmID,
        setFarmID: setFarmID,
        clearFarmID: clearStoredFarmID,
      }}
    >
      {props.children}
    </FarmContext.Provider>
  );
};

export default FarmContext;
